export default __webpack_public_path__ + "static/media/pulidora.d6a06b25.svg";